// @flow
import "isomorphic-fetch"
import handleMutationError from "./handleMutationError"

import { MAPBOX_ACCESS_TOKEN } from "./config"

import {
  VALIDATE_EMAIL_ROUTE,
  SIGNUP_ROUTE,
  LOGIN_ROUTE,
  KIOSK_LOGIN_ROUTE,
  REFRESH_ROUTE,
  FORGOT_EMAIL_ROUTE,
  ROUTES
} from "./routes"

import client from "./client"

export async function callAPI(routeName: string, body: {}): Promise<Response> {
  const route = ROUTES.get(routeName)
  if (!route) {
    throw new Error(`No route named ${routeName} exists.`)
  }
  return await fetch(route.url, {
    method: route.method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body)
  })
}

export {
  VALIDATE_EMAIL_ROUTE,
  SIGNUP_ROUTE,
  LOGIN_ROUTE,
  KIOSK_LOGIN_ROUTE,
  REFRESH_ROUTE,
  FORGOT_EMAIL_ROUTE,
  MAPBOX_ACCESS_TOKEN,
  client,
  handleMutationError
}



// WEBPACK FOOTER //
// ./src/API/index.js